import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../services/tealium/dist/es/types/shared/products.js';
import '../services/tealium/dist/es/events/event-properties-provider.js';
import '@swc/helpers';
import 'react';
import { dispatchTrackErrorEvent } from '../services/tealium/dist/es/events/use-track-error-event.js';
import { isArray } from '@grandvisionhq/utils';
import { mapDeliveryEstimation } from '../mappers/delivery-estimation.js';
import { GET_DELIVERY_ESTIMATION } from '../operations/queries/get-delivery-estimation.js';
import '../operations/queries/get-estimated-delivery-by-skus.js';
import '../operations/queries/get-shipping-methods-for-cart.js';

const useGetDeliveryEstimationMessage = (items, shippingMethodKey, hasRxLens = false)=>{
    var ref, ref1, ref2, ref3;
    const { dateTime: { formatDate  } , getFormattedLabel , locale , getLabel ,  } = useIntl();
    const { data , loading , error: error1  } = useQuery(GET_DELIVERY_ESTIMATION, {
        variables: {
            input: {
                skuQuantityPairs: items,
                shippingMethodKey
            }
        }
    });
    const deliveryEstimation = mapDeliveryEstimation(data, locale);
    let deliveryMessage = '';
    if (deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : deliveryEstimation.deliveryDate) {
        deliveryMessage = getFormattedLabel('products.deliveryIndicator.deliveryIndicationFullDate', {
            labelData: {
                deliveryDate: formatDate(deliveryEstimation.deliveryDate, 'short'),
                deliveryMethod: deliveryEstimation.shippingMethodDescription
            }
        });
    } else if (hasRxLens && (deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : (ref = deliveryEstimation.deliveryRanges) === null || ref === void 0 ? void 0 : ref.minWithPrescription) && (deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : (ref1 = deliveryEstimation.deliveryRanges) === null || ref1 === void 0 ? void 0 : ref1.maxWithPrescription)) {
        deliveryMessage = getFormattedLabel('products.deliveryIndicator.deliveryIndicationRanges', {
            labelData: {
                deliveryMin: deliveryEstimation.deliveryRanges.minWithPrescription,
                deliveryMax: deliveryEstimation.deliveryRanges.maxWithPrescription,
                deliveryMethod: deliveryEstimation.shippingMethodDescription
            }
        });
    } else if ((deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : (ref2 = deliveryEstimation.deliveryRanges) === null || ref2 === void 0 ? void 0 : ref2.min) && (deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : (ref3 = deliveryEstimation.deliveryRanges) === null || ref3 === void 0 ? void 0 : ref3.max)) {
        deliveryMessage = getFormattedLabel('products.deliveryIndicator.deliveryIndicationRanges', {
            labelData: {
                deliveryMin: deliveryEstimation.deliveryRanges.min,
                deliveryMax: deliveryEstimation.deliveryRanges.max,
                deliveryMethod: deliveryEstimation.shippingMethodDescription
            }
        });
    }
    if (error1) {
        console.error(error1);
        dispatchTrackErrorEvent(()=>Promise.resolve({
                Error_Source: 'Server',
                Error_Code: 'Pdp',
                Error_Details: isArray(error1.graphQLErrors) ? error1.graphQLErrors.map((error)=>error.message
                ).join(',') : error1.message,
                Error_Message: getLabel('products.deliveryIndicator.fallbackMessage')
            })
        );
    }
    return {
        deliveryMessage,
        loading,
        error: error1
    };
};

export { useGetDeliveryEstimationMessage };
//# sourceMappingURL=use-get-delivery-estimation-message.js.map
